<template>
    <div class="wrm-device-pane">
        <el-radio-group v-model="equipmentComplaintType" @change="handleRadioChange">
            <el-radio :label="ECTYPES.DAY">日常投诉</el-radio>
            <el-radio :label="ECTYPES.MONTH">月度评价</el-radio>
            <el-radio :label="ECTYPES.YEAR">年度评价</el-radio>
        </el-radio-group>
        <m-pane
            v-if="visible"
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="page.pageTotal"
            :loading="loading"
            :currentPage="page.pageNo"
            :class="equipmentComplaintType === ECTYPES.DAY ? 'day-m-pane' : ''"
            searchId="abnormalAssessDeviceSearchId"
            :pageID="pageID"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <div slot="table-module-btn">
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <el-button :loading="exportLoading" size="mini" icon="el-icon-download" @click="handleExport"></el-button>
                </el-tooltip>
            </div>
        </m-pane>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import bigDataLog from '@/utils/bigDataLog'
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/supplierPanel';
import { dayConfig, monthConfig, yearConfig } from './deviceConfig.js';
import { getExceptionDetailSummary, exportEquipment } from '../../../api/warehouseResourceManagement/abnormalAssess.js';

// 类型 SRM_EQUIPMENT_COMPLAINT_TYPE
const ECTYPES = {
    DAY: '1',
    MONTH: '2',
    YEAR: '3',
}

export default {
    components: { paper, mPane },
    data() {
        return {
            ECTYPES,
            equipmentComplaintType: ECTYPES.DAY,
            reportCode: 'SRM_ABNORMAL_ASSESS_DEVICE_EXP',
            visible: true,
            loading: false,
            exportLoading: false,
            totalData: [],
            searchObj: {
                createStartTime: dayjs().subtract(90, 'd').format('YYYY-MM-DD 00:00:00'),
                createEndTime: dayjs().format('YYYY-MM-DD 23:59:59'),
            },
            config: dayConfig,
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            // dict: []
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
        };
    },
    computed: {
        pageID() {
            return 'abnormalAssessDevicePageId' + this.equipmentComplaintType
        }
    },
    methods: {
        getTableData() {
            this.loading = true
            getExceptionDetailSummary(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list
                }
            }).finally(() => { this.loading = false });
        },
        getParams() {
            const params = JSON.parse(JSON.stringify(this.searchObj));
            params.assessmentExceptionType = '2' // 2 设备类
            params.equipmentComplaintType = this.equipmentComplaintType
            params.pageNo = this.page.pageNo
            params.pageSize = this.page.pageSize
            if (params.assessmentMonthList && params.assessmentMonthList.length) {
                params.assessmentStartMonth = dayjs(params.assessmentMonthList[0]).format('YYYY-MM')
                params.assessmentEndMonth = dayjs(params.assessmentMonthList[1]).format('YYYY-MM')
            }
            if (params.assessmentYearList && params.assessmentYearList.length) {
                params.assessmentYearList = params.assessmentYearList.map(item => dayjs(item).format('YYYY'))
            } else {
                delete params.assessmentYearList
            }
            if (params.supplierCode) {
                params.supplierCodeList = params.supplierCode.split(',')
            }
            if (params.logicalWarehouseCode) {
                params.logicalWarehouseCodeList = params.logicalWarehouseCode.split(',')
            }
            if (params.createTimeArr && params.createTimeArr.length) {
                params.createStartTime = dayjs(params.createTimeArr[0]).format('YYYY-MM-DD HH:mm:ss')
                params.createEndTime = dayjs(params.createTimeArr[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            delete params.assessmentMonthList
            delete params.supplierCode
            delete params.supplierName
            delete params.logicalWarehouseCode
            delete params.logicalWarehouseName
            delete params.createTimeArr
            return params
        },
        searchChange(data) { // 点击查询
            this.page.pageNo = 1;
            this.searchObj = data;
            this.getTableData();
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,供应商异常管理,异常考核,设备类-查询'); } catch (e) { }
        },
        pageChange(pageNo) { // 切换分页页数
            this.page.pageNo = pageNo;
            this.getTableData();
        },
        sizeChange(pageSize) { // 切换分页显示条数
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.getTableData();
        },
        handleExport() {
            const params = {
                ...this.getParams(),
                // orderBy: 'create_time',
                // orderByType: 'desc',
            }
            delete params.pageNo
            delete params.pageSize
            this.exportLoading = true
            exportEquipment(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data || '文件处理中，稍后请留意右上角文件中心下载文件！')
                }
            }).finally(() => {
                this.exportLoading = false
            })
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,供应商异常管理,异常考核,设备类-导出'); } catch (e) { }

        },
        handleRadioChange(val) {
            const configObj = {
                [ECTYPES.DAY]: dayConfig,
                [ECTYPES.MONTH]: monthConfig,
                [ECTYPES.YEAR]: yearConfig,
            }
            this.visible = false
            setTimeout(() => {
                this.config = configObj[val]
                this.visible = true
                this.searchObj = {
                    createStartTime: dayjs().subtract(90, 'd').format('YYYY-MM-DD 00:00:00'),
                    createEndTime: dayjs().format('YYYY-MM-DD 23:59:59'),
                }
                this.page.pageNo = 1;
                this.page.pageSize = 10;
                this.totalData = []
                this.getTableData();
            })
        }
    },
    mounted() {
        this.getTableData();
    }
};
</script>
<style lang="less">
.wrm-device-pane {
    #mPane3.day-m-pane .el-table {
        min-height: calc(100vh - 288px);
        max-height: calc(100vh - 288px);
    }

    #mPane3 .el-table {
        min-height: calc(100vh - 250px);
        max-height: calc(100vh - 250px);
    }

    .el-radio-group {
        margin-bottom: 10px;
    }
}
</style>
